import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingSecurity3 = props => (
    <section id="outsourcing-security-section3" className="my pt-5">
        <Container>
            <div className='AccordionUI bg p-5'>
                <p className='text-center m-0'>
                    <Trans i18nKey="services:outsourcingSecurity:section-3.text"
                        components={{
                            outsourcingAdvantages: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_advantages.path')} className="link" />,
                            outsourcingService: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing.path')} className="link" />
                        }}
                    />
                </p>
            </div>
        </Container>
    </section>
);

export default OutsourcingSecurity3;
